// extracted by mini-css-extract-plugin
export default {"line":"styles_line__wuB4G"};